<template>
  <div class="login-wrapper">
    <bg-pic-container></bg-pic-container>
    <form-container :token-is-invalid="tokenIsInvalid"></form-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import FormContainer from './FormContainer'
  import BgPicContainer from './BgPicContainer'

  export default {
    components: {
      FormContainer,
      BgPicContainer
    },

    computed: {
      ...mapState(['fromRoute']),

      tokenIsInvalid () {
        const fromRoute = this.fromRoute,
          meta = fromRoute.hasOwnProperty('meta') && fromRoute.meta
        return meta && meta.tokenIsInvalid || false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/Login/Login.vue